import { render, staticRenderFns } from "./ellipses.vue?vue&type=template&id=55d57b97&"
import script from "./ellipses.vue?vue&type=script&lang=js&"
export * from "./ellipses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports